import React from "react";
import LGWashingPageTemplate from "./LGWashingPageTemplate";

const relatedLinks = [
  { to: "/lg-appliance-service-bangalore", label: "LG Appliance Service" },
  { to: "/lg-washing-machine-service-bangalore", label: "LG Washing Machine Service" },
  { to: "/lg-washing-machine-repair-bangalore", label: "LG Washing Machine Repair" },
  { to: "/lg-washing-machine-not-spinning", label: "LG Washing Machine Not Spinning" },
  { to: "/lg-washing-machine-noise-problem", label: "LG Washing Machine Noise Problem" },
];

const LGWashingMachineDrumRepair = () => {
  return (
    <LGWashingPageTemplate
      title="LG Washing Machine Drum Repair in Bangalore"
      description="LG washing machine drum repair in Bangalore for drum movement issues, bearing faults, imbalance, and spin-cycle breakdowns."
      keywords="lg washing machine drum repair, lg drum issue service, lg washing machine repair bangalore"
      path="/lg-washing-machine-drum-repair"
      bannerTitle="LG Washing Machine Drum Repair"
      intro={<>A faulty <span style={{ fontWeight: 'bold' }}>drum repair</span> can stop your LG washing machine from washing, rinsing, or spinning properly. Our Bangalore technicians inspect drum movement, bearings, shaft alignment, and connected components to provide reliable repair support.</>}
      highlights={[
        "Drum movement and bearing inspection",
        "Support for jammed or unstable drums",
        "Diagnosis for spin and rotation failures",
        "Repair service for connected motor and shaft issues",
      ]}
      issues={[
        "Drum not rotating freely",
        "Drum stuck or misaligned",
        "Spin cycle failing due to drum faults",
        "Noise caused by bearing or drum wear",
      ]}
      relatedLinks={relatedLinks}
    />
  );
};

export default LGWashingMachineDrumRepair;
